import type { ErrorLike, OperationVariables } from "@apollo/client";
import type { useQuery } from "@apollo/client/react";

export interface GqData<T> {
    data: T | undefined;
    error?: ErrorLike;
    loading: boolean;
    // networkStatus: NetworkStatus;
    refetch?: () => Promise<unknown>;
}

/**
 * Transform a GraphQL query result by applying a function to "map" the data.
 * Forwards loading and errors statuses. (works similarly to `Promise.then`)
 *
 * @returns query result, with `data` returned by {@link extract()}, `undefined` when loading
 */
export function extractData<T, TV extends OperationVariables, TR>(
    query: useQuery.Result<T, TV>,
    extract: (data: NoInfer<T>) => TR,
): GqData<TR> {
    const { error, loading, data, refetch, dataState } = query;
    return {
        // NB: We do not support partial and streaming results here yet
        data: dataState === "complete" ? extract(data) : undefined,
        error,
        loading,
        // networkStatus,
        refetch,
    };
}
